import type { LearningEngineDecision } from "@/lib/learning-engine/types";

export const START_LEARNING_FALLBACK = "/dashboard";

/** Deterministic destination from the canonical engine decision. */
export function resolveStartLearningDestination(
  decision: Pick<LearningEngineDecision, "target_route" | "target_lesson_id" | "is_locked"> | null | undefined,
): string {
  if (!decision || decision.is_locked) return START_LEARNING_FALLBACK;
  if (decision.target_route && decision.target_route.startsWith("/")) return decision.target_route;
  if (decision.target_lesson_id) return `/lesson/${decision.target_lesson_id}`;
  return START_LEARNING_FALLBACK;
}
